import { twMerge } from "tailwind-merge";
import { LoaderIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { useBillBookletsQuery } from "@services/jointBillServices/queries";
import { BillBookletModalPdfViewer } from "./BillBookletModalPdfViewer";

interface IBillDetailizationModalProps extends IUseModalProps {
  billBookletFileUrl: string;
}

export const BillBookletModal: React.FC<IBillDetailizationModalProps> = (
  props,
) => {
  const { billBookletFileUrl, ...rest } = props;
  const modal = useModal(rest);

  const { data, isPending } = useBillBookletsQuery({ url: billBookletFileUrl });

  return (
    <Modal
      modal={modal}
      className="relative md:max-w-7xl"
      title=" "
      subtitle=" "
    >
      {data && <BillBookletModalPdfViewer data={data.data} />}
      <div
        className={twMerge(
          "absolute right-1/2 top-1/2 z-50 hidden -translate-y-1/2 translate-x-1/2",
          isPending && "block",
        )}
      >
        <LoaderIcon className={twMerge("animate-spin")} />
      </div>
    </Modal>
  );
};
